import React, { useState } from "react";
import { SarsModel, SarsStatus } from "../../domain/SarsModel";
import {
  List,
  ListItem,
  ListItemText,
  Popover,
} from "@material-ui/core";
import { PauseDialog } from "./Dialogs/PauseDialog";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { reopenSAR, unpauseSar } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { RejectDialog } from "./Dialogs/RejectDialog";
import { ConfirmActionDialog } from "./Dialogs/ConfirmActionDialog";

export type SelectStateProps = {
  sar: SarsModel;
};

export const SelectStateButton: React.FC<SelectStateProps> = (props) => {

  const dispatch = useDispatch();
    
  const [isShowingList, setIsShowingList] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPauseDialog, setIsPauseDialog] = useState(false);
  const [isUnpauseDialog, setIsUnpauseDialog] = useState(false);
  const [isRejectDialog, setIsRejectDialog] = useState(false);  



  const handleSelectMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
    setIsShowingList(true);
  };
   

    const handleSelectMenuClose = () => {
        setIsShowingList(false);
        setAnchorEl(null);
    }

  const isClosed = props.sar.status === SarsStatus.Closed;
  const isRejected = props.sar.status === SarsStatus.Rejected;
  const isPaused = props.sar.status === SarsStatus.Paused; 
  const sarClosedOrRejected = isClosed || isRejected;
  const showClose = !isRejected && !isPaused;
  const showUnpause = !sarClosedOrRejected && isPaused;
  const showPause = !sarClosedOrRejected && !isPaused;
  const showOpen = isClosed && !isRejected && !isPaused;
  const showInternalReview = !sarClosedOrRejected && !isPaused;  
  const showICO = !sarClosedOrRejected && !isPaused;  
  const showReject = !sarClosedOrRejected && !isPaused;  
    
 
    return (
      <>
        <AppBarButton
          text="Set State"
          data-test="set-state-button"
          onClick={handleSelectMenuOpen}
        />

        {isShowingList ? (
          <Popover
            open={isShowingList}
            onClose={handleSelectMenuClose}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <List>
              {showOpen && (
                <ListItem
                  data-test="sla-open-button"
                  button
                  onClick={() => {
                    dispatch(reopenSAR(props.sar.id));
                    setIsShowingList(false);
                    setAnchorEl(null);
                  }}
                >
                  <ListItemText primary="Open" />
                </ListItem>
              )}

              {showPause && (
                <ListItem
                  data-test="pause-listItem"
                  button
                  onClick={() => setIsPauseDialog(true)}
                >
                  <ListItemText primary="Pause" />
                </ListItem>
              )}

              {showUnpause && (
                <ListItem
                  data-test="unpaused-listItem"
                  button
                  onClick={() => setIsUnpauseDialog(true)}
                >
                  <ListItemText primary="Un-pause" />
                </ListItem>
              )}

              {showReject && (
                <ListItem
                  data-test="reject-listItem"
                  button
                  onClick={() => setIsRejectDialog(true)}
                >
                  <ListItemText primary="Reject" />
                </ListItem>
              )}

              {showClose && (
                <ListItem
                  data-test="close-button"
                  button
                  onClick={() => {
                    setIsShowingList(false);
                    setAnchorEl(null);
                  }}
                >
                  <ListItemText primary="Close" />
                </ListItem>
              )}

              {showInternalReview && (
                <ListItem
                  data-test="sla-internalReview-button"
                  button
                  onClick={() => {
                    setIsShowingList(false);
                    setAnchorEl(null);
                  }}
                >
                  <ListItemText primary="Internal Review" />
                </ListItem>
              )}

              {showICO && (
                <ListItem
                  data-test="sla-ico-button"
                  button
                  onClick={() => {
                    setIsShowingList(false);
                    setAnchorEl(null);
                  }}
                >
                  <ListItemText primary="ICO" />
                </ListItem>
              )}
            </List>
          </Popover>
        ) : null}

        <PauseDialog
          {...props}
          open={isPauseDialog}
          onClose={() => {
            setIsPauseDialog(false);
            handleSelectMenuClose();
          }}
        />

        <ConfirmActionDialog
          {...props}
          action={unpauseSar}
          title={"Un-pause SAR"}
          confirmMsg={
            "Confirm you want to un-pause this Subject Access Request"
          }
          onClose={() => {
            setIsUnpauseDialog(false);
            handleSelectMenuClose();
          }}
          open={isUnpauseDialog}
        />

        <RejectDialog
          {...props}
          onClose={() => {
            setIsRejectDialog(false);
            handleSelectMenuClose();
          }}
          open={isRejectDialog}
        />
      </>
    );
};


